'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getHeight = function getHeight(container) {
    return container.getBoundingClientRect().height;
};

var ScrollView = function (_Component) {
    _inherits(ScrollView, _Component);

    function ScrollView() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ScrollView);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollView.__proto__ || Object.getPrototypeOf(ScrollView)).call.apply(_ref, [this].concat(args))), _this), _this._currentScrollBottom = 0, _this._handleScroll = function () {
            var container = _this._scrollContainer;

            if (!container) return;

            requestAnimationFrame(function () {
                var height = getHeight(container);
                var scrollTop = container.scrollTop;
                var scrollBottom = container.scrollHeight - height - scrollTop;

                _this._currentScrollBottom = scrollBottom;

                _this.props.onScroll({ scrollBottom: scrollBottom, scrollTop: scrollTop });
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ScrollView, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.scrollToBottom();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.restoreScrollPositionOnUpdate) {
                this.restoreScrollPosition();
            }
        }
    }, {
        key: 'restoreScrollPosition',
        value: function restoreScrollPosition() {
            this.setScrollBottom(this._currentScrollBottom);
        }
    }, {
        key: 'scrollToTop',
        value: function scrollToTop() {
            this.setScrollTop(0);
        }
    }, {
        key: 'scrollToBottom',
        value: function scrollToBottom() {
            this.setScrollBottom(0);
        }
    }, {
        key: 'setScrollBottom',
        value: function setScrollBottom(value) {
            var container = this._scrollContainer;
            if (!container) return;
            var height = getHeight(container);
            container.scrollTop = container.scrollHeight - height - value;
        }
    }, {
        key: 'setScrollTop',
        value: function setScrollTop(value) {
            if (!this._scrollContainer) return;
            this._scrollContainer.scrollTop = value;
        }
    }, {
        key: '_renderContent',
        value: function _renderContent() {
            var _this2 = this;

            var children = this.props.children;

            if (typeof children === 'function') {
                return children({ restoreScrollPosition: function restoreScrollPosition() {
                        return _this2.restoreScrollPosition();
                    } });
            }
            return children;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                height = _props.height,
                width = _props.width,
                style = _props.style,
                children = _props.children,
                className = _props.className;


            return _react2.default.createElement(
                'div',
                {
                    className: className,
                    onScroll: this._handleScroll,
                    style: _extends({
                        overscrollBehavior: 'contain contain',
                        height: height,
                        width: width,
                        overflowY: 'scroll'
                    }, style),
                    ref: function ref(_ref2) {
                        return _this3._scrollContainer = _ref2;
                    }
                },
                _react2.default.createElement(
                    'div',
                    {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: '100%',
                            justifyContent: 'flex-end'
                        }
                    },
                    this._renderContent()
                )
            );
        }
    }]);

    return ScrollView;
}(_react.Component);

ScrollView.defaultProps = {
    onScroll: function onScroll() {},
    width: 100,
    height: 100,
    style: {},
    restoreScrollPositionOnUpdate: true
};
exports.default = ScrollView;